module.exports = __webpack_public_path__ + "static/media/getty_Images_1204596112_desktop.b26e2fa0.jpg";